import { EntitySelectorsFactory } from '@ngrx/data';

import { SubActividad } from './sub-actividades.model';

export const subActividadesSelectors =
  new EntitySelectorsFactory().create<SubActividad>('SubActividad');

export const selectAllSubActividades = subActividadesSelectors.selectEntities;